/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Cost_NeedInputs */

const en_endpoint_cost_need = /** @type {(inputs: Endpoint_Cost_NeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I need`)
};

const zh_hans1_endpoint_cost_need = /** @type {(inputs: Endpoint_Cost_NeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我需要`)
};

const pt_br2_endpoint_cost_need = /** @type {(inputs: Endpoint_Cost_NeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preciso de`)
};

const es_endpoint_cost_need = /** @type {(inputs: Endpoint_Cost_NeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Necesito`)
};

const fr_endpoint_cost_need = /** @type {(inputs: Endpoint_Cost_NeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`J’ai besoin de`)
};

const de_endpoint_cost_need = /** @type {(inputs: Endpoint_Cost_NeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich brauche`)
};

const ru_endpoint_cost_need = /** @type {(inputs: Endpoint_Cost_NeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мне нужно`)
};

const it_endpoint_cost_need = /** @type {(inputs: Endpoint_Cost_NeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi servono`)
};

/**
* | output |
* | --- |
* | "I need" |
*
* @param {Endpoint_Cost_NeedInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_cost_need = /** @type {((inputs?: Endpoint_Cost_NeedInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Cost_NeedInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_cost_need(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_cost_need(inputs)
	if (locale === "es") return es_endpoint_cost_need(inputs)
	if (locale === "fr") return fr_endpoint_cost_need(inputs)
	if (locale === "de") return de_endpoint_cost_need(inputs)
	if (locale === "ru") return ru_endpoint_cost_need(inputs)
	if (locale === "it") return it_endpoint_cost_need(inputs)
	return en_endpoint_cost_need(inputs)
});